import createReducer from '../createReducer';
import { FETCH_CHART_TILES_SUCCESS } from '../../actions/charts';

const newestTile = tileset => tileset
  .sort((tile1, tile2) => (
    tile2.timestamp - tile1.timestamp
  ))
  .filter((_, index) => index === 0);

const initialState = {};

const handlers = {
  [FETCH_CHART_TILES_SUCCESS]: (_, { tiles }) => {
    const { SST, SEA_ICE, ...allOtherTiles } = tiles;

    // Sort SST tiles by time in descending order and use the most recent only
    const sstTile = newestTile(SST);
    const seaIceTile = newestTile(SEA_ICE);

    return {
      ...allOtherTiles,
      SST: sstTile,
      SEA_ICE: seaIceTile,
    };
  },
};

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/charts/tiles.js